import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideLanguages = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m5 8 6 6m-7 0 6-6 2-3M2 5h12M7 2h1m14 20-5-10-5 10m2-4h6"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLucideLanguages);
const Memo = memo(ForwardRef);
export default Memo;
